import config from '@config/index'
import I18n from 'i18n-js'
import de from './de.json'
import en from './en.json'

I18n.translations = { de, en }
I18n.missingTranslation = (s) => `TR: ${s}`
I18n.missingTranslationPrefix = 'TR: '

// I18n.locale = config.defaultLang

export const _ = (scope, options) => {
  return I18n.t(scope, options)
}

export const setLanguage = (locale) => {
  I18n.locale = locale
}

export const getLang = () => I18n.locale

export const getAllLangCodes = () => config.langs
